module.exports = __webpack_public_path__ + "static/img/rank_66.ddaae40.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_66.png
// module id = XLOs
// module chunks = 0